import axios from 'axios';

export const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_URL });

export const adminApi = () => {
  const token = localStorage.getItem('tf_admin_token');
  return axios.create({
    baseURL: API_URL,
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
};

export const imgUrl = (src, width = 1600) => {
  if (!src) return '';
  const abs = src.startsWith('http') ? src : `${process.env.REACT_APP_BACKEND_URL}${src}`;
  if (abs.includes('images.unsplash.com')) {
    try {
      const u = new URL(abs);
      u.searchParams.set('w', String(width));
      u.searchParams.set('q', '68');
      u.searchParams.set('auto', 'format,compress');
      return u.toString();
    } catch (e) {
      return abs;
    }
  }
  return abs;
};

const SRCSET_WIDTHS = [480, 768, 1024, 1440];

export const imgSrcSet = (src) => {
  if (!src || !src.includes('images.unsplash.com')) return undefined;
  return SRCSET_WIDTHS.map((w) => `${imgUrl(src, w)} ${w}w`).join(', ');
};

export const formatError = (err, fallback = 'Une erreur est survenue') => {
  const detail = err?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || '').filter(Boolean).join(' ');
  return fallback;
};

// Lance la génération IA d'une fiche produit en tâche de fond puis attend le résultat
// (évite les coupures de proxy/Cloudflare sur les requêtes longues).
export const runProductAi = async (payload, onTick) => {
  const { data } = await adminApi().post('/admin/seo/product-optimize/start', payload);
  for (let i = 1; i <= 90; i += 1) {
    await new Promise((r) => setTimeout(r, 2000));
    if (onTick) onTick(i * 2);
    const { data: job } = await adminApi().get(`/admin/seo/job/${data.job_id}`);
    if (job.status === 'done') return job.result;
    if (job.status === 'error') throw new Error(job.error || 'Génération impossible');
  }
  throw new Error('La génération a pris trop de temps — réessayez');
};
